module.exports = __webpack_public_path__ + "img/red_015.33a5b15e.png";